 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"79fd5335","chunk-022b702c":"8ed97ced","chunk-cdd5f0c2":"0df227cd","chunk-14d75b20":"8839f024","chunk-00978fa7":"850a510d","chunk-24d3420e":"e96b7488","chunk-1ca8281b":"ee616fcf","chunk-0911d405":"c85d9eec","chunk-43c7bb8f":"c4c041f0","chunk-58934d4e":"fd7e3e68","chunk-49406954":"6e2972ab","chunk-5f16e7ae":"308abefa","chunk-c1a30040":"75f9a951","chunk-b070a446":"f95649d8","chunk-6a64e8d8":"62310ecf","chunk-5c4c15db":"afae0605","chunk-715dedd2":"a5920f7b","chunk-75b3866b":"be7f51d2","chunk-76f8f848":"85b13e5c","chunk-2d22d3f4":"54a4a1f7","chunk-964c0f12":"5b5a1b58","chunk-9d1d567c":"490313f3","chunk-951f247a":"7dc11952","chunk-2751310e":"9a1b5eb8","chunk-2d22693c":"7833251a","chunk-1c18ca17":"4e65d636","chunk-020a0648":"694a2acd","chunk-2d2172bd":"faed18a6","chunk-6fd1db39":"0053795f","chunk-6b27f690":"405340f1","chunk-e708e626":"ba0c2802","chunk-09111cd7":"2641d80f","chunk-1df54136":"25dbba1c","chunk-29bebfab":"361307ec","chunk-2d0a3159":"846c0f16","chunk-2d0dd7af":"ea3dcbd1","chunk-2d0ddba1":"897997e5","chunk-2d22b970":"ab1a9071","chunk-2d21a841":"d9543865","chunk-2d237ffc":"925f9505","chunk-30702762":"adbf98e0","chunk-382dac7b":"f9bc6fea","chunk-3e204b49":"850eeae6","chunk-44edfcb6":"64318236","chunk-5e745215":"c5e916be","chunk-4dbafbbe":"2945d72e","chunk-50d21eb3":"473e0627","chunk-51936753":"0c90f5ed","chunk-57cc81a2":"9ba481a7","chunk-df2ead5c":"7fbaa38f","chunk-672cdc65":"dace9eb9","chunk-2d0aa281":"0d842714","chunk-2d0ae5d6":"12a895ae","chunk-2d0da355":"51f74876","chunk-2d216ba8":"6f400283","chunk-39bda81c":"02b85ef7","chunk-b57fc804":"00815784","chunk-6724917a":"630e494a","chunk-6fec8487":"4cc29f91","chunk-76f043c1":"2a2fe184","chunk-7b4f1712":"12a5d440","chunk-a9632ad4":"3a1f4f1e","chunk-c99a9d2a":"12322ffe","chunk-c86e599c":"f22bc2af","chunk-ea0efcd2":"5b3ac0ea","chunk-ecae29fc":"1f4cec19","chunk-f8432fd6":"e2f85001","chunk-2d2223ef":"644af9f5","chunk-2d607d30":"57545849","chunk-2f83f030":"05baef40","chunk-4aad5e3d":"c4e0feac","chunk-5051c692":"68de82c7","chunk-62fe80ef":"5adbf9e9","chunk-71fa889d":"6234f55d","chunk-7d47e309":"3aa2d25a","chunk-343edb6e":"8ec2ab0e","chunk-17a63ea5":"d986d0ae","chunk-2d209b31":"ff3e603d","chunk-0987dada":"56888cc2","chunk-3982b5fc":"801d0fd7","chunk-6596017c":"07642eca","chunk-6943e552":"0dbf05bf","chunk-55693694":"195828c8","chunk-743c2ddb":"a76340f5","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-334b20be":"f9b98439","chunk-ba57138a":"53db8550","chunk-c0f817d4":"36ced69b","chunk-f210cb80":"f7509f78","chunk-10d582ee":"715cf228","chunk-1d94d3f1":"5caa51aa","chunk-2d0cc2ee":"e7fbe2af","chunk-3e2e8798":"f91cf4ce","chunk-401d5cd2":"753b3242","chunk-8d67e87c":"c28e1cd8","chunk-7457c560":"de003d3e","chunk-2cf0b788":"cdd48ac9","chunk-e0125934":"1a83ec46"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01347eea":1,"chunk-022b702c":1,"chunk-cdd5f0c2":1,"chunk-14d75b20":1,"chunk-24d3420e":1,"chunk-1ca8281b":1,"chunk-0911d405":1,"chunk-43c7bb8f":1,"chunk-58934d4e":1,"chunk-49406954":1,"chunk-c1a30040":1,"chunk-b070a446":1,"chunk-6a64e8d8":1,"chunk-5c4c15db":1,"chunk-715dedd2":1,"chunk-75b3866b":1,"chunk-76f8f848":1,"chunk-964c0f12":1,"chunk-9d1d567c":1,"chunk-951f247a":1,"chunk-2751310e":1,"chunk-1c18ca17":1,"chunk-020a0648":1,"chunk-6fd1db39":1,"chunk-6b27f690":1,"chunk-e708e626":1,"chunk-09111cd7":1,"chunk-1df54136":1,"chunk-29bebfab":1,"chunk-30702762":1,"chunk-382dac7b":1,"chunk-3e204b49":1,"chunk-44edfcb6":1,"chunk-5e745215":1,"chunk-4dbafbbe":1,"chunk-50d21eb3":1,"chunk-51936753":1,"chunk-57cc81a2":1,"chunk-672cdc65":1,"chunk-39bda81c":1,"chunk-6724917a":1,"chunk-6fec8487":1,"chunk-7b4f1712":1,"chunk-a9632ad4":1,"chunk-c99a9d2a":1,"chunk-c86e599c":1,"chunk-ea0efcd2":1,"chunk-ecae29fc":1,"chunk-f8432fd6":1,"chunk-2d607d30":1,"chunk-2f83f030":1,"chunk-4aad5e3d":1,"chunk-5051c692":1,"chunk-62fe80ef":1,"chunk-71fa889d":1,"chunk-343edb6e":1,"chunk-17a63ea5":1,"chunk-0987dada":1,"chunk-3982b5fc":1,"chunk-6596017c":1,"chunk-6943e552":1,"chunk-55693694":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-334b20be":1,"chunk-ba57138a":1,"chunk-c0f817d4":1,"chunk-f210cb80":1,"chunk-10d582ee":1,"chunk-1d94d3f1":1,"chunk-401d5cd2":1,"chunk-8d67e87c":1,"chunk-7457c560":1,"chunk-2cf0b788":1,"chunk-e0125934":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"14130ea8","chunk-022b702c":"ba5cb7a1","chunk-cdd5f0c2":"f1baeb9b","chunk-14d75b20":"3dbe6557","chunk-00978fa7":"31d6cfe0","chunk-24d3420e":"9a05de5d","chunk-1ca8281b":"0bb5e88d","chunk-0911d405":"9cb06b22","chunk-43c7bb8f":"2792dee8","chunk-58934d4e":"1c0aedbd","chunk-49406954":"aa556149","chunk-5f16e7ae":"31d6cfe0","chunk-c1a30040":"ea0a40ef","chunk-b070a446":"85ae2e5d","chunk-6a64e8d8":"65825594","chunk-5c4c15db":"832f84b9","chunk-715dedd2":"19e04091","chunk-75b3866b":"cd5a6cf6","chunk-76f8f848":"fc5f3796","chunk-2d22d3f4":"31d6cfe0","chunk-964c0f12":"e1fb4ad0","chunk-9d1d567c":"8d29b8d6","chunk-951f247a":"6dcc9a81","chunk-2751310e":"7e1ecbad","chunk-2d22693c":"31d6cfe0","chunk-1c18ca17":"167bee36","chunk-020a0648":"3a29b023","chunk-2d2172bd":"31d6cfe0","chunk-6fd1db39":"b4f75ce8","chunk-6b27f690":"3719c382","chunk-e708e626":"0fb8de66","chunk-09111cd7":"1a0fb1f8","chunk-1df54136":"11a57673","chunk-29bebfab":"ef0da253","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2d237ffc":"31d6cfe0","chunk-30702762":"4dfd10e1","chunk-382dac7b":"1703942f","chunk-3e204b49":"9e4fc9a0","chunk-44edfcb6":"8d62bdfb","chunk-5e745215":"0b1c0a72","chunk-4dbafbbe":"52e370db","chunk-50d21eb3":"9f69edb5","chunk-51936753":"5c327261","chunk-57cc81a2":"37df1425","chunk-df2ead5c":"31d6cfe0","chunk-672cdc65":"1a715947","chunk-2d0aa281":"31d6cfe0","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-39bda81c":"8c28c1e8","chunk-b57fc804":"31d6cfe0","chunk-6724917a":"e1d0fec9","chunk-6fec8487":"aac3e2f8","chunk-76f043c1":"31d6cfe0","chunk-7b4f1712":"a659d23b","chunk-a9632ad4":"ddb6d2a6","chunk-c99a9d2a":"0c9b0e85","chunk-c86e599c":"dd31d40b","chunk-ea0efcd2":"468b9773","chunk-ecae29fc":"2457469d","chunk-f8432fd6":"2457469d","chunk-2d2223ef":"31d6cfe0","chunk-2d607d30":"d09cf3eb","chunk-2f83f030":"f2e3d023","chunk-4aad5e3d":"2405960a","chunk-5051c692":"cef4cfbb","chunk-62fe80ef":"c0261f0b","chunk-71fa889d":"07cc3c21","chunk-7d47e309":"31d6cfe0","chunk-343edb6e":"65af4178","chunk-17a63ea5":"0da95f5b","chunk-2d209b31":"31d6cfe0","chunk-0987dada":"db5d03c5","chunk-3982b5fc":"96e1e641","chunk-6596017c":"6d34c20d","chunk-6943e552":"b196006c","chunk-55693694":"2e1a912a","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-334b20be":"47b392f8","chunk-ba57138a":"c62c4385","chunk-c0f817d4":"7bfbbbb7","chunk-f210cb80":"5da84a9f","chunk-10d582ee":"91868441","chunk-1d94d3f1":"a140772d","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-401d5cd2":"6cb98cce","chunk-8d67e87c":"951ed169","chunk-7457c560":"d4ad834b","chunk-2cf0b788":"a97febbf","chunk-e0125934":"367bb202"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
